<template>
  <div>
    <div class="wrapper">
      <h3>{{$t('yourInformation.registComplete') }}</h3>
      <next-button
        :label="$t('auth.registProfile')"
        @click.prevent="onSubmit"
        :disabled="false"
      />
    </div>
  </div>
</template>

<script>
import HeaderTitle from '../design/HeaderTitleSlot'
import Heading from '../components/atoms/Heading'
import NextButton from '../components/atoms/NextButton'

export default {
  components: {
    HeaderTitle,
    Heading,
    NextButton
  },
  methods: {
    onSubmit() {
        this.$router.push({ name: "account" });
    }
  }
}
</script>

<style scoped>
  .wrapper {
    border: 2px solid #d7d7d7;
    border-radius: 10px;
    width: 100%;
    padding: 40px;
    margin-top: 80px;
  }
.next-button {
  margin-top: 20px;
}
</style>
